export default __webpack_public_path__ + "static/media/solarlight.e94c9cf5.png";